 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"videocall":"videocall","agoraclient":"agoraclient","ringer":"ringer","twilio-client":"twilio-client","controls":"controls"}[chunkId]||chunkId) + "." + {"chunk-009661df":"437b17a6","chunk-0cdd8aa5":"3a2632c9","chunk-1a418c5c":"1732f28b","chunk-79cf5852":"ecd26bc9","chunk-2d0a4c17":"77334b97","chunk-2d0ac448":"b144bd79","chunk-2d20f5c3":"cfcfe7f4","chunk-2d21ecdb":"75b92c78","chunk-40810d26":"9a005dbc","chunk-4d96801b":"832ac623","chunk-65c6ca5a":"987ff822","chunk-6724aa68":"3fce6bd9","chunk-679a2ce1":"da024b26","chunk-3eaa0c93":"f5d3ba7e","chunk-6899e037":"afed033d","chunk-69986c76":"550a6ddc","chunk-6c9fef63":"6c30dce3","chunk-2d0b3411":"8adc0717","chunk-96438a5e":"beef9fa2","chunk-ab981264":"de43b696","chunk-5a6bf464":"0137d811","chunk-cfafa4dc":"52e27607","chunk-09d3cef0":"0e5e7433","chunk-194940be":"b9cfb593","chunk-2e695f5c":"4144c504","chunk-377181dc":"eacc688d","chunk-2d0ccf5c":"a47bc342","chunk-9faabf0a":"2e03addf","chunk-3da0b5e9":"76baa5ba","chunk-59d3e101":"261670e6","chunk-174447c6":"76c3853c","chunk-26e47d30":"73f9b98f","chunk-68f12f32":"d8dad852","chunk-6e397eec":"74129be3","chunk-a0c1c0f6":"aab2f431","chunk-069c44d1":"4d174cf0","chunk-3be630d8":"8366e10f","chunk-a641fb96":"dfb2b4a7","chunk-12e8ff64":"232f75ac","chunk-3d337c2a":"019ab9af","chunk-000060ab":"2ab0de1e","chunk-e679a95e":"5ca43920","chunk-f49161ba":"bee8cccb","videocall":"f2e3e727","agoraclient":"d4aa02ae","ringer":"21ff1bbc","twilio-client":"3590b771","controls":"9191a0c6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-4d96801b":1,"chunk-3eaa0c93":1,"chunk-6899e037":1,"chunk-69986c76":1,"chunk-5a6bf464":1,"chunk-26e47d30":1,"chunk-68f12f32":1,"chunk-069c44d1":1,"chunk-3be630d8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"videocall":"videocall","agoraclient":"agoraclient","ringer":"ringer","twilio-client":"twilio-client","controls":"controls"}[chunkId]||chunkId) + "." + {"chunk-009661df":"31d6cfe0","chunk-0cdd8aa5":"31d6cfe0","chunk-1a418c5c":"31d6cfe0","chunk-79cf5852":"31d6cfe0","chunk-2d0a4c17":"31d6cfe0","chunk-2d0ac448":"31d6cfe0","chunk-2d20f5c3":"31d6cfe0","chunk-2d21ecdb":"31d6cfe0","chunk-40810d26":"31d6cfe0","chunk-4d96801b":"44f9f53f","chunk-65c6ca5a":"31d6cfe0","chunk-6724aa68":"31d6cfe0","chunk-679a2ce1":"31d6cfe0","chunk-3eaa0c93":"0aa325aa","chunk-6899e037":"d674543e","chunk-69986c76":"f9cc9e35","chunk-6c9fef63":"31d6cfe0","chunk-2d0b3411":"31d6cfe0","chunk-96438a5e":"31d6cfe0","chunk-ab981264":"31d6cfe0","chunk-5a6bf464":"812a8652","chunk-cfafa4dc":"31d6cfe0","chunk-09d3cef0":"31d6cfe0","chunk-194940be":"31d6cfe0","chunk-2e695f5c":"31d6cfe0","chunk-377181dc":"31d6cfe0","chunk-2d0ccf5c":"31d6cfe0","chunk-9faabf0a":"31d6cfe0","chunk-3da0b5e9":"31d6cfe0","chunk-59d3e101":"31d6cfe0","chunk-174447c6":"31d6cfe0","chunk-26e47d30":"15faea24","chunk-68f12f32":"d91efe40","chunk-6e397eec":"31d6cfe0","chunk-a0c1c0f6":"31d6cfe0","chunk-069c44d1":"7fbab0c8","chunk-3be630d8":"d3af1aa6","chunk-a641fb96":"31d6cfe0","chunk-12e8ff64":"31d6cfe0","chunk-3d337c2a":"31d6cfe0","chunk-000060ab":"31d6cfe0","chunk-e679a95e":"31d6cfe0","chunk-f49161ba":"31d6cfe0","videocall":"31d6cfe0","agoraclient":"31d6cfe0","ringer":"31d6cfe0","twilio-client":"31d6cfe0","controls":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
